import React, { Component } from "react";

import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";

import "./Menu.css";

const navLinkClass = ({ isActive }) => (isActive ? "main-menu-active" : "");
class Menu extends Component {
  render() {
    return (
      <nav className="nav-desktop">
        <ul className="main-menu">
          <li>
            <NavLink className={navLinkClass} end to="/">
              Home
            </NavLink>
          </li>
          <li>
            <NavLink className={navLinkClass} to="/about">
              About Us
            </NavLink>
          </li>
          <li>
            <NavLink className={navLinkClass} to="/services">
              Services
            </NavLink>
          </li>
          <li>
            <NavLink className={navLinkClass} to="/book">
              Book
            </NavLink>
          </li>
          <li>
            <NavLink className={navLinkClass} to="/careers">
              Careers
            </NavLink>
          </li>
          <li>
            <NavLink className={navLinkClass} to="/contacts">
              Contacts
            </NavLink>
          </li>
        </ul>
      </nav>
    );
  }
}

class MenuMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: false,
    };
  }

  burgerToggle = (toggleOption) => {
    let state = this.state;

    if (toggleOption === "none") {
      state.menuVisible = false;
    } else {
      if (state.menuVisible === true) {
        state.menuVisible = false;
      } else {
        state.menuVisible = true;
      }
    }
    this.setState(state);
  };

  render() {
    return (
      <nav className="nav-mobile">
        <div className="nav-mobile-bg"></div>
        <div className="mobile-menu-icon" onClick={this.burgerToggle}>
          &#9776;
        </div>
        <div className="mobile-logo">
          <NavLink className={navLinkClass} end to="/">
            <div className="header-logo-mobile" onClick={() => this.burgerToggle("none")}></div>
          </NavLink>
        </div>
        <div
          className={
            this.state.menuVisible === true ? "nav-mobile-menu-bg nav-mobile-menu-bg-visible" : "nav-mobile-menu-bg"
          }
          onClick={this.burgerToggle}
        ></div>
        <div
          className={this.state.menuVisible === true ? "nav-mobile-menu nav-mobile-menu-visible" : "nav-mobile-menu"}
        >
          <ul className="main-menu-mobile" onClick={this.burgerToggle}>
            <NavLink className={navLinkClass} end to="/">
              <li className="main-menu-li-shade">Home</li>
            </NavLink>
            <NavLink className={navLinkClass} to="/about">
              <li>About Us</li>
            </NavLink>
            <NavLink className={navLinkClass} to="/services">
              <li className="main-menu-li-shade">Services</li>
            </NavLink>
            <NavLink className={navLinkClass} to="/book">
              <li>Book</li>
            </NavLink>
            <NavLink className={navLinkClass} to="/careers">
              <li className="main-menu-li-shade">Careers</li>
            </NavLink>
            <NavLink className={navLinkClass} to="/contacts">
              <li>Contacts</li>
            </NavLink>
          </ul>
        </div>
      </nav>
    );
  }
}

export { Menu, MenuMobile };
